export const TASK_TYPE_SETTINGS_DATA_UPDATE = 'SETTINGS_DATA_UPDATE';
export const TASK_TYPE_LAST_CUSTOM_DATA_UPDATE = 'LAST_CUSTOM_DATA_UPDATE';
export const UNPUBLISH_BANNER_MENU_TYPE = 'menu';
export const UNPUBLISH_BANNER_SETTINGS_TYPE = 'settings';
